package core.validation.field

import core.validation.validator.DoubleValidator

class TimeRangeField(
    firstInitialValue: String = "",
    secondInitialValue: String = "",
    vararg validators: DoubleValidator<String>,
) : DoubleFieldImpl<String>(
    firstInitialValue = firstInitialValue,
    secondInitialValue = secondInitialValue,
    validators = validators,
)
